import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./AboutPage.css";

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-bg"></div>
        <div className="about-container">
          <div className="about-hero-content">
            <span className="badge">Lựa chọn thông minh</span>
            <h1>MUA XE VINFAST GIÁ TỐT</h1>
            <h2>NHẬN XE TRỰC TIẾP TỪ NHÀ MÁY</h2>
            <p className="hero-desc">
              Bạn muốn mua xe VinFast chính hãng với mức giá tốt nhất?
              <br />
              Mình từng là người mua xe lần đầu, phải mày mò rất nhiều, nên mình
              sẽ hướng dẫn lại bạn cách thực hiện.
            </p>
            <a href="#quy-trinh" className="btn btn-primary btn-large cta-btn">
              Xem Quy Trình <span className="arrow">↓</span>
            </a>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="about-why">
        <div className="about-container">
          <h3 className="section-title">Vì sao nên chọn?</h3>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h4>Giá tốt hơn</h4>
              <p>
                Không qua trung gian, được hỗ trợ thêm ưu đãi từ Sale nhưng vẫn
                đầy đủ chính sách VinFast.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">✨</div>
              <h4>Xe mới 100%</h4>
              <p>
                Xe xuất xưởng theo đơn hàng, hạn chế xe tồn kho, xe trưng bày
                hoặc xe đã qua nhiều lượt trải nghiệm.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h4>An tâm minh bạch</h4>
              <p>
                Hợp đồng rõ ràng, tránh các rủi ro về nguồn gốc và giấy tờ xe.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏠</div>
              <h4>Tiện lợi tại nhà</h4>
              <p>
                Tư vấn – đặt xe – làm thủ tục online, xe được giao đến địa chỉ
                bạn mong muốn.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Promotions Section */}
      <section className="about-why" style={{ backgroundColor: "var(--light-bg)" }}>
        <div className="about-container">
          <h3 className="section-title">Ưu Đãi Khi Mua Xe</h3>
          <div className="features-grid">
            <div className="feature-card highlight-card" style={{ borderColor: "var(--primary-color)" }}>
              <div className="feature-icon">🎁</div>
              <h4>Ưu đãi riêng từ Sale</h4>
              <p>
                Khi đặt xe qua mình, bạn sẽ nhận được thêm voucher hỗ trợ giảm
                giá riêng và được tư vấn lựa chọn phương án mua xe phù hợp nhất.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⭐</div>
              <h4>Công an – Quân đội</h4>
              <p>
                Giảm thêm <strong>5% giá xe</strong> cho khách hàng thuộc lực
                lượng Công an, Quân đội Việt Nam.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💎</div>
              <h4>Thành viên VinClub</h4>
              <p>
                Khách hàng VinClub được hưởng thêm quyền lợi theo hạng thẻ lên đến 1,5%.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h4>Mua xe online O2O</h4>
              <p>
                Mua xe đơn giản như mua sắm online, thanh toán linh hoạt và an toàn tuyệt đối.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Differences Section */}
      <section className="about-differences">
        <div className="about-container">
          <h3 className="section-title">Một vài khác biệt nhỏ</h3>
          <div className="differences-list">
            <div className="diff-item">
              <div className="diff-check">💡</div>
              <p>
                <strong>Không có quà tặng showroom</strong> → Thay bằng ưu đãi
                trực tiếp vào giá xe, bạn chủ động mua thứ mình cần hơn.
              </p>
            </div>
            <div className="diff-item">
              <div className="diff-check">🤫</div>
              <p>
                <strong>Không có lễ giao xe hoành tráng</strong> → Đổi lại là xe
                được giao tận nơi, nhanh gọn và riêng tư.
              </p>
            </div>
            <div className="diff-item">
              <div className="diff-check">📋</div>
              <p>
                <strong>Bạn cần tự đăng ký xe</strong> → Sale hỗ trợ miễn phí
                toàn bộ thủ tục.
              </p>
            </div>
            <div className="diff-item">
              <div className="diff-check">⏳</div>
              <p>
                <strong>Có thể cần chờ xe xuất xưởng</strong> → Vì xe được sản
                xuất theo đúng đơn đặt hàng của bạn.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section id="quy-trinh" className="about-process">
        <div className="about-container">
          <h3 className="section-title">Quy trình mua xe</h3>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-number">1</div>
              <div className="timeline-content">
                <h4>Đặt xe trên hệ thống VinFast</h4>
                <p>Thao tác nhanh chóng với sự hướng dẫn chi tiết.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">2</div>
              <div className="timeline-content">
                <h4>Thanh toán cọc</h4>
                <p>Chuyển khoản trực tiếp vào tài khoản công ty VinFast.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">3</div>
              <div className="timeline-content">
                <h4>Ký hợp đồng mua xe</h4>
                <p>Hợp đồng điện tử minh bạch, rõ ràng pháp lý.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">4</div>
              <div className="timeline-content">
                <h4>Nhà máy hoàn thiện xe</h4>
                <p>Thanh toán phần còn lại khi có thông báo nhận xe.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">5</div>
              <div className="timeline-content">
                <h4>Nhận xe và hành trình mới 🚗</h4>
                <p>Xe được vận chuyển và bàn giao đến tận tay bạn.</p>
              </div>
            </div>
          </div>
          <div className="process-note">
            <span className="note-icon">ℹ️</span>
            <p>
              Nếu vay ngân hàng, Sale sẽ hỗ trợ toàn bộ thủ tục để ngân hàng
              giải ngân và bạn nhận xe thuận lợi.
            </p>
          </div>
        </div>
      </section>

      {/* Story & CTA Section */}
      <section className="about-story">
        <div className="about-container">
          <div className="story-card">
            <p className="story-text">
              "Mình sẽ hỗ trợ bạn thực hiện tất cả các bước trên, để mua xe một
              cách đơn giản nhất."
            </p>
            <div className="story-cta">
              <Link to="/booking" className="btn btn-primary btn-large">
                Liên Hệ Tư Vấn Ngay
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
